module.exports = __webpack_public_path__ + "static/media/JSWSTEEL_F1.393af06d.txt";